<cerrix-loader [cerrixTab]="tab"></cerrix-loader>
<div #chartContainer></div>
